import React from "react";
import ReservationSegmentCardDateSelector from "../ReservationSegmentCardDateSelector";

class DateSection extends React.Component {

  constructor(props) {
    super(props);
  };

  render() {
    return (
      <ReservationSegmentCardDateSelector {...this.props} read_only={this.props.reservation_segment.ru_res_apa_id || this.props.reservation_segment.ru_reservation_id || this.props.read_only ? true : false}/>
    );
  };

};

export default DateSection
